/**
 * Backdrop for screens shown before sign-in (login, 2FA, org invite). They
 * render on a bare route with no app shell, so this stands in for the shell
 * that owns the viewport: full height on the flat paper background.
 */
export const AUTH_BACKDROP = 'min-h-screen bg-paper';
